import { Box } from '@factorialco/deprecated-design-system'

import { SIZES } from 'modules/job_catalog/components/DevJobCatalogTree/types'

const CollapsibleLine = () => {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
      style={{ top: `${SIZES.EDGE_RELATIVE_POSITION_TOP}px` }}
    >
      <Box background="grey400" width="s12" height="s12" borderRadius={{ all: 'abs100' }} />
      <Box flexDirection="row" alignItems="center">
        <Box
          width="s1"
          height="s16"
          border={{
            left: {
              width: 's2',
              style: 'solid',
              color: 'grey400',
            },
          }}
          borderRadius={{ all: 'abs012' }}
        />
      </Box>
    </Box>
  )
}

export default CollapsibleLine
